/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-components';
import type { CitationState, CitationSlots } from './Citation.types';
import type { JSXElement } from '@fluentui/react-utilities';
/**
 * Render the final JSX of Citation
 */
export const renderCitation_unstable = (state: CitationState): JSXElement => {
  assertSlots<CitationSlots>(state);

  return <state.root />;
};
